import { MappedClass, MappedProperty, MappedPropertyArray } from '@h5s/util-object';
import { ZPrinterFiscalConfigPayment } from './z-printer-fiscal-config-payment';

@MappedClass()
export class ZPrinterFiscalConfigPaymentListApplicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedPropertyArray(() => ZPrinterFiscalConfigPayment)
  value: ZPrinterFiscalConfigPayment[];
}
